import { SortDescriptor } from '@progress/kendo-data-query';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { IBrickInstanceTargetingAction } from 'src/app/store/utility/IBrickInstanceTargetingAction';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';

export class LoadMoreDirectoryValues implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Load More Directory Values';

   constructor(public brickInstanceId: string) {}
}

export class ClearAndStartLoadingDirectoryValues implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Clear And Start Loading Directory Values';

   constructor(public brickInstanceId: string) {}
}

export class SetSearchValue implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Set Search Value';

   constructor(public brickInstanceId: string, public searchValue: string) {}
}

export class SetIsCallerFilterActive implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Set Is Caller Filter Active';

   constructor(public brickInstanceId: string, public isCallerFilterActive: boolean) {}
}

export class SetIsCallTriggeredDirectoryAssociationsFilterActive implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Set Is Call Triggered Directory Associations Filter Active';

   constructor(public brickInstanceId: string, public isOrganisationAssociationsFilterActive: boolean) {}
}

export class SetTemporarySearchColumns implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Set Temporary Search Columns';

   constructor(public brickInstanceId: string, public temporarySearchColumns: DirectoryColumn[]) {}
}

export class DirectorySearchValueChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Directory Search Value Changed';

   constructor(public brickInstanceId: string, public searchValue: string, public keepSelection: boolean = false) {}
}

export class DirectorySearchInGivenColumns implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Directory Search In Given Columns';

   constructor(public brickInstanceId: string, public searchValue: string, public searchColumns: DirectoryColumn[]) {}
}

export class EmptyDirectory implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Empty Directory';

   constructor(public brickInstanceId: string) {}
}

export class ToggleDirectoryFilterForIncomingCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Toggle Directory Filter For Incoming Call';

   constructor(public brickInstanceId: string, public isFilteringPossible: boolean) {}
}

export class ToggleDirectoryFilterForCaller implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Toggle Directory Filter For Caller';

   constructor(public brickInstanceId: string) {}
}

export class DirectoryRowDoubleClicked implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Directory Row Double Clicked';

   constructor(public brickInstanceId: string, public item: DirectoryEntryRemoteDto, public columnFieldId: string) {}
}

export class DirectoryBrowserEntrySelected implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Directory Entry Selected';

   constructor(public brickInstanceId: string, public directoryId: number) {}
}

export class DirectoryBrowserChangeCustomSorting implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Directory Browser Change Custom Sorting';

   constructor(public brickInstanceId: string, public customSorting: SortDescriptor[]) {}
}

export class ResetDirectorySearch implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Reset Directory Search';

   constructor(public brickInstanceId: string) {}
}

export class DirectoryBrowserSelectNextEntry implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Select Next Entry';

   constructor(public brickInstanceId: string, public direction: 'up' | 'down', public step = 1) {}
}

export class DirectoryBrowserMakeCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Make Call ';

   constructor(public brickInstanceId: string, public directoryEntryToCall: DirectoryEntryRemoteDto) {}
}

export class DirectoryBrowserCallFromColumn implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Make Call From Column';

   constructor(public brickInstanceId: string, public columnName: string) {}
}

export class DirectoryBrowserChangeMatchingPercentage implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Change Phonetic Search Matching Percentage';

   constructor(public brickInstanceId: string, public matchingPercentage: number) {}
}

export class ClearAndStartLoadingAllDirectoryValues {
   public static readonly type = '[Directory Browser Behaviour] Clear And Start Loading All Directory Values Except The Directory Given';

   constructor(public brickInstanceId: string = '') {}
}

export class RemoveUnusedSelectedEntries {
   public static readonly type = '[Directory Browser Behaviour] Remove Unused Selected Entries Except The Directory Given';

   constructor(public brickInstanceId: string = '') {}
}

export class RefreshEditedDirectoryEntry {
   public static readonly type = '[Directory Browser Behaviour] Refresh Edited Directory Entry';

   constructor(public id: number) {}
}

export class RemoveEntryFromAllDirectories {
   public static readonly type = '[Directory Browser Behaviour] Remove Directory Entry From Loaded Values In All Directories';

   constructor(public id: number) {}
}

export class EditEntryInAllDirectories {
   public static readonly type = '[Directory Browser Behaviour] Update Directory Entry In Loaded Values In All Directories';

   constructor(public id: number, public entry: DirectoryEntryRemoteDto) {}
}

export class DirectoryNewIncomingCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] New Incoming Call';

   constructor(public brickInstanceId: string, public callId: number) {}
}

export class DirectoryCallEnded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Directory Browser Behaviour] Call Ended';

   constructor(public brickInstanceId: string) {}
}
